<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container pb-5">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Shapefile importeren</h1>
        </div>
        <div class="controls">
            <div class="fab small" matTooltip="Terug naar overzicht" matTooltipPosition="below" routerLink="/management">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>

    <form [formGroup]="importForm">
        <div class="row">
            <div class="col-6">
                <ng-select
                    (change)="onCustomerAreaChange()"
                    [items]="customerAreas"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="customer_area_id"
                    placeholder="Selecteer klantgebied">
                </ng-select>
            </div>

            @if (importForm.get('customer_area_id')?.value) {
                <div class="col-6">
                    <ng-select
                        [addTag]="addNewInspection"
                        [items]="inspections"
                        addTagText="Nieuwe inspectie toevoegen"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="inspection_id"
                        placeholder="Selecteer inspectie">
                    </ng-select>
                </div>
            }
        </div>

        @if (importForm.get('customer_area_id')?.value && importForm.get('inspection_id')?.value) {
            <div>
                <input #fileInput (change)="onFileSelected($event)" [disabled]="features.length > 0" accept=".zip,.shp,.dbf,.prj,.shx" style="display: none;" type="file"/>
                <button (click)="fileInput.click()" [disabled]="features.length > 0" color="primary" mat-raised-button>
                    <i class="fas fa-upload"></i> {{selectedFileName || 'Selecteer Shapefile ZIP'}}
                </button>
                @if (shapefileCombinations.length > 0) {
                    <div class="combinations-section pt-3">
                        <h5>Inhoud shapefile</h5>
                        <p>Selecteer de delen uit het shapefile die je wilt importeren:</p>
                        <mat-selection-list
                            #shapefileList
                            (selectionChange)="onSelectionChange($event)"
                            [disabled]="features.length > 0"
                            [multiple]="true"
                            class="combinations-selection-list">
                            @for (combination of shapefileCombinations; track combination) {
                                <mat-list-option [selected]="combination.selected" [value]="combination" checkboxPosition="before" class="combination-option">
                                    <div class="combination-content">
                                        <div class="combination-header">
                                            <span class="combination-name">{{combination.name}}</span>
                                            <span class="combination-files">
                                                @if (combination.hasShp) {
                                                    <span class="file-type shp">SHP</span>
                                                }
                                                @if (combination.hasDbf) {
                                                    <span class="file-type dbf">DBF</span>
                                                }
                                                @if (combination.hasPrj) {
                                                    <span class="file-type prj">PRJ</span>
                                                }
                                                @if (combination.hasShx) {
                                                    <span class="file-type shx">SHX</span>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </mat-list-option>
                            }
                        </mat-selection-list>
                        <div class="selection-actions">
                            @if (features.length < 1) {
                                <button (click)="selectAllCombinations()" mat-button>
                                    Selecteer Alles
                                </button>
                                <button (click)="deselectAllCombinations()" mat-button>
                                    Deselecteer Alles
                                </button>
                                <button (click)="processSelectedCombinations()" [disabled]="selectedCombinations.length === 0" color="accent" mat-raised-button>
                                    Importeer geselecteerde delen ({{selectedCombinations.length}})
                                </button>
                            } @else {
                                <button (click)="openDataDialog()" color="accent" mat-raised-button>
                                    <i class="fas fa-table"></i>
                                    Bekijk data ({{features.length}} features)
                                </button>
                            }
                        </div>
                    </div>
                }
                @if (features.length > 0) {
                    <div>
                        <h5>Punaisekoppeling</h5>
                        <p>Map de waarden uit de shapefile naar het juiste veld in een punaise: </p>
                        <div class="form-check mb-3">
                            <mat-checkbox formControlName="autoFillLocationFields">
                                Automatisch locatievelden vullen (straat, postcode, huisnummer, plaats) op basis van GPS-coördinaten
                            </mat-checkbox>
                        </div>
                        <div formArrayName="pushpinMappings">
                            @for (control of pushpinMappingsFormArray.controls; track control; let i = $index) {
                                <div class="mapping">
                                    <label>
                                        {{pushpinFieldLabels.get(pushpinFields[i])?.name}}
                                        @if (automaticMappings.has('pushpin-' + i)) {
                                            <span class="auto-mapping-badge" title="Automatisch gemapped">
                                                <i class="fas fa-magic"></i>
                                            </span>
                                        }
                                    </label>
                                    <ng-select
                                        (change)="onMappingManualChange('pushpin', i)"
                                        [clearable]="true"
                                        [formControl]="control"
                                        appendTo="body"
                                        placeholder="Kies een eigenschap uit de shapefile">
                                        @for (prop of shapefileProperties; track prop) {
                                            <ng-option [value]="prop">
                                                <b>{{prop}}</b><span class="select-option-value-info">{{prop | shapefileValueInfo: features}}</span>
                                            </ng-option>
                                        }
                                    </ng-select>
                                    <div class="hint">{{pushpinFieldLabels.get(pushpinFields[i])?.description}}</div>
                                </div>
                            }
                        </div>
                        <h5 class="mt-3">Punaisedeel koppeling</h5>
                        <p>Map de waarden van een makeringsitem met de waarden uit de shapefile: </p>
                        <div formArrayName="pushpinPartMappings">
                            @for (control of pushpinPartMappingsFormArray.controls; track control; let i = $index) {
                                <div class="mapping">
                                    <label>
                                        {{pushpinPartFieldLabels.get(pushpinPartFields[i])?.name}}
                                        @if (automaticMappings.has('pushpinpart-' + i)) {
                                            <span class="auto-mapping-badge" title="Automatisch gemapped">
                                                <i class="fas fa-magic"></i>
                                            </span>
                                        }
                                    </label>
                                    <ng-select
                                        (change)="onMappingManualChange('pushpinpart', i); onMappingChange(pushpinPartFields[i])"
                                        [clearable]="true"
                                        [formControl]="control"
                                        appendTo="body"
                                        placeholder="Kies een eigenschap uit de shapefile">
                                        @for (prop of shapefileProperties; track prop) {
                                            <ng-option [value]="prop">
                                                <b>{{prop}}</b><span class="select-option-value-info">{{prop | shapefileValueInfo: features}}</span>
                                            </ng-option>
                                        }
                                    </ng-select>
                                    <div class="hint">{{pushpinPartFieldLabels.get(pushpinPartFields[i])?.description}}</div>
                                </div>
                            }
                        </div>
                        <!-- Standaard terugvalwaarden sectie -->
                        @if (availableDefaultFields.length > 0) {
                            <div>
                                <h5 class="mt-3">Standaard terugvalwaarden</h5>
                                <p>Stel standaard waarden in voor velden zonder shapefile koppeling:</p>
                                @for (field of availableDefaultFields; track field) {
                                    <div>
                                        @if (fieldItemsMap.get(field.items)?.length > 0) {
                                            <div class="field-mapping">
                                                <label>{{field.label}}</label>
                                                <ng-select
                                                    [clearable]="true"
                                                    [formControlName]="field.name"
                                                    [placeholder]="'Selecteer ' + field.label.toLowerCase()">
                                                    @for (item of fieldItemsMap.get(field.items); track item) {
                                                        <ng-option [value]="item.id">
                                                            @for (displayProp of field.displayProperty; track displayProp; let isFirst = $first) {
                                                                {{item[displayProp]}}@if (!isFirst) {
                                                                    <span> </span>
                                                                }
                                                            }
                                                        </ng-option>
                                                    }
                                                </ng-select>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        @for (field of mappableFields; track field) {
                            <div [ngClass]="field.name + '-mapping-section'">
                                @if (fieldMappings.get(field.name)?.size > 0) {
                                    <div>
                                        <h5 class="mt-3">{{field.label}} koppeling</h5>
                                        <p>Map de {{field.label.toLowerCase()}} waarden uit de shapefile: </p>
                                        @for (mapping of fieldMappings.get(field.name) | keyvalue; track mapping) {
                                            <div class="field-mapping">
                                                <label>{{mapping.key}}</label>
                                                <ng-select
                                                    (ngModelChange)="updateFieldMapping(field.name, mapping.key, $event)"
                                                    [clearable]="true"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [ngModel]="mapping.value"
                                                    [placeholder]="'Selecteer ' + field.label.toLowerCase()">
                                                    @for (item of fieldItemsMap.get(field.items); track item) {
                                                        <ng-option [value]="item.id">
                                                            @for (displayProp of field.displayProperty; track displayProp; let isFirst = $first) {
                                                                {{item[displayProp]}}@if (!isFirst) {
                                                                    <span> </span>
                                                                }
                                                            }
                                                        </ng-option>
                                                    }
                                                </ng-select>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <div class="d-flex justify-content-end mt-4">
                            <button (click)="import()" [disabled]="importing !== null || importForm.invalid" color="primary" mat-raised-button type="submit">
                                @if (importing === null) {
                                    <span>Importeren</span>
                                } @else {
                                    <span>Bezig met importeren... ({{importing}}/{{totalPushpins}})</span>
                                }
                            </button>
                        </div>
                    </div>
                }
            </div>
        }
    </form>
</div>
